module.exports = __webpack_public_path__ + "static/media/klub-2.911712e6.png";